import React, { memo } from 'react'
import { AnyStyledComponent } from 'styled-components'

import { ButtonWrapper, IconImage, UserIconWrapper } from './header-section-styles'
import ExternalLink from './../../common/external-link'
import { HeaderSectionTransport } from './../../../transports/region-landing-page-transport'
import UserCheckIcon from '../../../assets/icons/userbar-icons/user-check.svg'
import UserHeaderIcon from '../../../assets/icons/userbar-icons/user-logo.svg'

type Navigation = HeaderSectionTransport['navigationSectionResponse']['navigation']

interface UserMenuMobileProps {
    navigation: Navigation
    isLoggedIn: boolean
    sitePathname?: string
    toggleUserSidebar: () => void
}

const UserMenuMobile: React.FC<UserMenuMobileProps> = ({ navigation, isLoggedIn, sitePathname, toggleUserSidebar }) => {
    const { loginButton } = navigation

    if (isLoggedIn) {
        return (
            <ButtonWrapper onClick={toggleUserSidebar}>
                <IconImage as={UserCheckIcon as AnyStyledComponent} />
            </ButtonWrapper>
        )
    }

    return (
        <ExternalLink href={`${loginButton.url}?target=${sitePathname}`} as={UserIconWrapper} noCrawl>
            <IconImage as={UserHeaderIcon as AnyStyledComponent} />
        </ExternalLink>
    )
}

export default memo(UserMenuMobile)
